import { memo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "@emotion/styled";

const SensorInfoWrapper = styled.div`
    width: 79px;
    position: absolute;
    left: 50%;
    margin-left: -35px;
    bottom: 12px;
    text-align: center;
    z-index: 3;
    color: #00cbaf;
    font-size: 14px;

    .sensor-tooltip-label {
        color: #00cbaf;
        display: flex;
        align-items: center;
        cursor: default;
    }
`;

const SensorListTooltip = ({ sensorNames }: { sensorNames: string[] }) => {
    const renderSensorTooltip = (props: any) => {
        return (
            <Tooltip className="tooltip-heatmap-sensors" {...props}>
                {sensorNames?.length ? (
                    <div>
                        <div className="tooltip-heatmap-sensors-title">
                            Sensors:
                        </div>
                        {sensorNames?.map(
                            (sensorName: string, index: number) => {
                                return (
                                    <div key={sensorName + String(index)}>
                                        <span>Sensor {index + 1}: </span>
                                        <span className="tooltip-heatmap-sensors-name">
                                            {sensorName}
                                        </span>
                                    </div>
                                );
                            }
                        )}
                    </div>
                ) : (
                    ""
                )}
            </Tooltip>
        );
    };

    return (
        <SensorInfoWrapper>
            {sensorNames?.length ? (
                <OverlayTrigger
                    placement="bottom"
                    overlay={renderSensorTooltip}
                    delay={{ show: 100, hide: 100 }}
                >
                    <span className="sensor-tooltip-label">
                        <span>Sensors</span>
                        <i className="material-icons">expand_more</i>
                    </span>
                </OverlayTrigger>
            ) : (
                <span className="sensor-tooltip-label">
                    <span>Sensors</span>
                    <i className="material-icons">expand_more</i>
                </span>
            )}
        </SensorInfoWrapper>
    );
};

export default memo(SensorListTooltip);
